import { inject, Injectable, Renderer2, RendererFactory2, RendererStyleFlags2 } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class ModalWrapperService {
    private readonly modalService = inject(NgbModal);
    private readonly renderer: Renderer2 = inject(RendererFactory2).createRenderer(null, null);

    public open(
        content: any,
        isSosh: boolean,
        options?: {
            wrapperClasses?: string[];
            containerClasses?: string[];
            windowClass?: string;
            backgroundColor?: string;
        },
    ): NgbModalRef {
        const modalWrapper = this.renderer.createElement('div');
        const oneStyle = this.renderer.createElement('div');
        this.renderer.addClass(modalWrapper, isSosh ? 'ecm-theme-sosh' : 'ecm-theme-orange');
        options?.wrapperClasses?.forEach((cls) => this.renderer.addClass(modalWrapper, cls));
        this.renderer.addClass(oneStyle, 'apply-one-style');
        options?.containerClasses?.forEach((cls) => this.renderer.addClass(oneStyle, cls));
        if (options?.backgroundColor) {
            this.renderer.setStyle(oneStyle, '--modal-bg-color', options.backgroundColor, RendererStyleFlags2.DashCase);
        }
        this.renderer.appendChild(document.body, modalWrapper);
        this.renderer.appendChild(modalWrapper, oneStyle);
        return this.modalService.open(content, { container: oneStyle, windowClass: options?.windowClass });
    }
}
